/**
 * SchedulerContainer.jsx
 * Layout wrapper that retrieves context from a parent route outlet
 * and passes it down to the appropriate SchedulerDashboard component.
 *
 * This container bridges router-level context (login status, auto-login
 * flag, startup flag, mobile flag) with the scheduler display, enabling
 * the dashboard to react to initial auth flow and session state.
 */

import React from "react";
import SchedulerDashboard from "./SchedulerDashboard";
import SchedulerDashboardMobile from "./SchedulerDashboardMobile";
import { useOutletContext } from "react-router-dom";

/**
 * SchedulerContainer
 * Retrieves outlet context provided by the parent route and renders
 * the appropriate dashboard component based on device type.
 */
const SchedulerContainer = () => {
  const context = useOutletContext() || {};

  const Component = context.isMobile
    ? SchedulerDashboardMobile
    : SchedulerDashboard;

  return (
    <Component
      isFirstLogin={context.isFirstLogin}
      wasAutoLogin={context.wasAutoLogin}
      wasStartup={context.wasStartup}
    />
  );
};

export default SchedulerContainer;
